// Generated by CoffeeScript 1.12.7
(function () {
  var extendedTypeOf;

  extendedTypeOf = function extendedTypeOf(obj) {
    var result;
    result = typeof obj;

    if (obj == null) {
      return 'null';
    } else if (result === 'object' && obj.constructor === Array) {
      return 'array';
    } else {
      return result;
    }
  };

  module.exports = {
    extendedTypeOf: extendedTypeOf
  };
}).call(this);